import type { SubmittedDocument } from "~/types/SubmittedDocument";
import { DocumentState } from "~/types/enums/DocumentState";

export type ArchiveFilters = {
  studentName: string;
  classroomName: string;
  assignmentName: string;
  name: string;
};

export function filterArchivedDocuments(documents: SubmittedDocument[], filters: ArchiveFilters) {
  return documents.filter(document => document.state === DocumentState.archived &&
    (Object.keys(filters) as (keyof ArchiveFilters)[]).every(key =>
      (document[key] ?? "").toLowerCase().includes(filters[key].trim().toLowerCase())
    )
  ).sort((a, b) =>
    (b.archivedAtTimestamp ?? b.lastUpdatedTimestamp ?? b.createOnTimestamp ?? 0) -
    (a.archivedAtTimestamp ?? a.lastUpdatedTimestamp ?? a.createOnTimestamp ?? 0)
  );
}

export function getRestoredDocumentState(document: SubmittedDocument): DocumentState {
  if (document.stateBeforeArchive && document.stateBeforeArchive !== DocumentState.archived &&
      Object.values(DocumentState).includes(document.stateBeforeArchive)) {
    return document.stateBeforeArchive;
  }
  // Older archives did not retain their state. Keep completed grading intact.
  return document.finishedGradingAtTimestamp || document.documentGradedState ||
    (document.earnedPoints != null && document.maxPoints != null)
    ? DocumentState.graded : DocumentState.submitted;
}
